module.exports = __webpack_public_path__ + "static/media/publication_4.4a9076c1.pdf";